import React from 'react';

const colors = {
  primary: 'bg-primary',
  secondary: 'bg-secondary',
  success: 'bg-success',
  danger: 'bg-danger',
  accent: 'bg-accent'
};

export default function ProgressBar({
  value = 0,
  max = 100,
  color = 'primary',
  showLabel = false,
  size = 'md',
  className = ''
}) {
  const percentage = Math.min(100, Math.max(0, (value / max) * 100));
  const colorClass = colors[color] || colors.primary;
  
  const heights = {
    sm: 'h-1',
    md: 'h-2',
    lg: 'h-3'
  };
  
  return (
    <div className={className}>
      <div className={`progress-bar ${heights[size]}`}>
        <div
          className={`progress-bar-fill ${colorClass}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      {showLabel && (
        <div className="mt-1 text-sm text-gray-500 text-right">
          {Math.round(percentage)}%
        </div>
      )}
    </div>
  );
}
